// Format required label for display based on required flag
export function requiredLabel(required, text) {
  return required ? (
    <>
      {text}
      <span className="required">*</span>
    </>
  ) : (
    text
  );
}

// Checks if an input field should be disabled or active
// Field should be disabled unless it's in the pre-upload status
export function fieldDisabled(fileStatus) {
  if (fileStatus === 'Needs Input') {
    return false;
  }

  return true;
}

// Turn a file progress percentage into the appropriate css class
export function progressToCssClass(progress) {
  switch (progress) {
    case 100:
      return 'card-success';
    case 0:
      return 'card-input';
    default:
      return 'card-loading';
  }
}
